// GENERATED FILE -- DO NOT EDIT BY HAND.
// Regenerate with: npm run learning:generate-preview-fixture (from shopify/)
// Source: each lesson's "## Knowledge Check" section in
// content-development/lessons/*/public-copy.md, parsed into
// shopify/data/lessons/*.json's `knowledge_check` field by
// shopify/scripts/generate-pilot-data.js. Edit public-copy.md, not this file.
window.OOLearningHubKnowledgeCheckData = {
  "choosing-a-mask": {
    "questions": [
      {
        "question": "Why might a glasses wearer care whether a mask is single-lens or dual-lens?",
        "answers": [
          "Dual-lens masks are commonly used for separate interchangeable corrective lenses where the model supports them",
          "Single-lens masks always have worse visibility",
          "Skirt color depends on the number of lenses"
        ],
        "correct_index": 0,
        "explanation": "Dual-lens masks often support separate corrective lenses for each eye, but only when the specific model is prescription-compatible."
      },
      {
        "question": "Does every dual-lens mask automatically support prescription lenses?",
        "answers": [
          "Yes, all dual-lens masks support every prescription",
          "No, prescription compatibility depends on the model",
          "Only if the skirt is clear"
        ],
        "correct_index": 1,
        "explanation": "Lens format can matter, but prescription compatibility still depends on the specific model. At Oceans Optics, all of our current dual-lens mask models are prescription-compatible, although the lens types and strengths available can vary by model."
      },
      {
        "question": "What does a clear skirt mainly change?",
        "answers": [
          "It allows more ambient and peripheral light into the mask",
          "It makes murky water clearer",
          "It changes the lens strength"
        ],
        "correct_index": 0,
        "explanation": "A clear skirt changes peripheral light around the mask. It does not change the clarity of the water itself."
      },
      {
        "question": "What still needs to be checked after comparing lens format, skirt color, and mask volume?",
        "answers": [
          "Fit, seal, comfort, and adjustment",
          "Only the frame color",
          "Whether the mask has the longest strap"
        ],
        "correct_index": 0,
        "explanation": "A mask choice is not complete until the snorkeler has confirmed that the mask fits and seals comfortably."
      }
    ]
  },
  "mask-fit-positioning-adjustment": {
    "questions": [
      {
        "question": "Where should the back strap generally sit?",
        "answers": [
          "Low on the neck",
          "On the crown of the head, above the ears",
          "Across the ears"
        ],
        "correct_index": 1,
        "explanation": "A crown-level strap position helps the mask sit evenly without pulling it downward."
      },
      {
        "question": "What is the goal when tightening a mask strap?",
        "answers": [
          "Make it as tight as possible",
          "Tighten gradually and evenly until it feels snug and comfortable",
          "Tighten one side first, then leave the other loose"
        ],
        "correct_index": 1,
        "explanation": "A good mask should seal through fit and positioning, not excessive strap pressure."
      },
      {
        "question": "If a mask is leaking from one side, what should you consider checking?",
        "answers": [
          "Both straps have been tightened evenly (1 is not longer than the other)",
          "The mask is not sitting over any hair",
          "The strap is not over tight",
          "All answers are correct"
        ],
        "correct_index": 3,
        "explanation": "A leak from one side can mean the mask has been adjusted incorrectly. Double check the straps are not too tight, they are evenly adjusted, the mask is sitting straight on your face, and that there is no hair anywhere under the seal."
      }
    ]
  },
  "mask-preparation-defogging-care": {
    "questions": [
      {
        "question": "What should you check before using an abrasive new-mask prep method?",
        "answers": [
          "Whether the lens material and coating allow it",
          "Whether the mask skirt is dark or clear",
          "Whether the snorkel is attached"
        ],
        "correct_index": 0,
        "explanation": "Abrasive methods can damage some prescription, coated, mirrored, or plastic lenses."
      },
      {
        "question": "Why are brand new masks especially prone to fogging?",
        "answers": [
          "The glass hasn't been used in water yet",
          "A thin manufacturing residue on the lens creates a rough surface fog clings to",
          "New masks are made from a different type of glass"
        ],
        "correct_index": 1,
        "explanation": "During curing, the silicone skirt releases a fine vapor that settles on the nearby lens. This film resists normal defogging until it's physically removed."
      },
      {
        "question": "What's the correct pairing of methods for mask care?",
        "answers": [
          "Toothpaste for every defog, before every snorkel",
          "Dish soap for new-mask prep, toothpaste for regular pre-snorkel defogging",
          "Toothpaste for new-mask prep, dish soap for regular pre-snorkel defogging"
        ],
        "correct_index": 2,
        "explanation": "Toothpaste breaks down the tougher manufacturing residue on a brand new lens. Dish soap is enough for the lighter, ongoing defog needed before each snorkel."
      },
      {
        "question": "What is the goal of defogging before a snorkel?",
        "answers": [
          "Leave a heavy layer of product on the lens",
          "Create a thin, even film that helps reduce fog",
          "Scrub the skirt until it changes color"
        ],
        "correct_index": 1,
        "explanation": "Too much product can smear the lens; a thin, even film is the goal."
      },
      {
        "question": "Why should a mask be fully dry before storage?",
        "answers": [
          "Damp storage can encourage odor and mold",
          "Dry masks no longer need straps",
          "Drying changes the prescription strength"
        ],
        "correct_index": 0,
        "explanation": "Damp storage encourages odor and mold, so drying the mask fully before it's put away matters."
      }
    ]
  },
  "choosing-and-setting-up-a-snorkel": {
    "questions": [
      {
        "question": "Which snorkel design usually requires water to be blast-cleared out through the top?",
        "answers": [
          "Classic / open-top J snorkel",
          "Dry-top snorkel",
          "A snorkel that is not attached to a mask"
        ],
        "correct_index": 0,
        "explanation": "Classic open-top snorkels are simple, but water entering the tube normally needs to be cleared with a strong exhale through the top."
      },
      {
        "question": "What's the key difference between a semi-dry and a dry-top snorkel?",
        "answers": [
          "A semi-dry reduces surface splash but doesn't fully seal if the top is submerged; a dry-top closes or restricts water entry when submerged",
          "A semi-dry is only used for scuba, a dry-top is only used for snorkeling",
          "They are the same design, just different colors"
        ],
        "correct_index": 0,
        "explanation": "A semi-dry's splash guard is a middle ground, it cuts down incidental splash but doesn't seal. A dry-top's valve mechanism actually closes when submerged."
      },
      {
        "question": "What does a purge valve do?",
        "answers": [
          "Lets water be expelled through the lower part of the snorkel instead of blasting it all out the top",
          "Prevents the snorkel from attaching to the mask",
          "Makes the tube fully rigid"
        ],
        "correct_index": 0,
        "explanation": "A purge valve gives water an exit point near the mouthpiece, which makes clearing easier for many beginners, but it's another part that needs rinsing and checking."
      },
      {
        "question": "Why is the left side the usual snorkel attachment side?",
        "answers": [
          "It follows the normal scuba convention and keeps the snorkel away from the regulator hose",
          "It always improves water clarity",
          "It makes every snorkel dry-top"
        ],
        "correct_index": 0,
        "explanation": "The left side is the normal scuba convention because the primary regulator hose generally comes from the right."
      },
      {
        "question": "What should the snorkel tube do when you are floating face-down?",
        "answers": [
          "Angle upward toward the surface",
          "Point downward into the water",
          "Sit loosely without a keeper or clip"
        ],
        "correct_index": 0,
        "explanation": "The snorkel needs to be positioned so the tip can stay above the surface during relaxed breathing."
      }
    ]
  },
  "choosing-fins": {
    "questions": [
      {
        "question": "Which fin style is commonly worn with dive boots?",
        "answers": [
          "Open-heel fins",
          "Closed-heel fins",
          "Fins with no foot pocket"
        ],
        "correct_index": 0,
        "explanation": "Open-heel fins usually use an adjustable strap and are commonly paired with boots."
      },
      {
        "question": "What is a real drawback of longer fin blades, even though they can move more water per stroke?",
        "answers": [
          "They require more space, strength, and control, and are less convenient for travel or shallow areas",
          "They are not allowed for snorkeling in most locations",
          "They remove the need for good kicking technique"
        ],
        "correct_index": 0,
        "explanation": "Longer blades can be efficient with the right strength and technique, but that comes with a real cost in space, control, and travel convenience."
      },
      {
        "question": "Why might short fins be useful in shallow reef areas?",
        "answers": [
          "They can make precise fin awareness and control easier",
          "They are always faster than long fins",
          "They remove the need for good technique"
        ],
        "correct_index": 0,
        "explanation": "Shorter blades can be easier to control around shallow or fragile environments, but body position and technique still prevent contact."
      },
      {
        "question": "What can happen if a fin is stiffer than a swimmer's leg strength and technique can support?",
        "answers": [
          "Unnecessary fatigue, inefficient kicking, or cramping",
          "Automatically faster swimming with no downside",
          "No effect on the swimmer either way"
        ],
        "correct_index": 0,
        "explanation": "Stiffness only helps when it's matched to the swimmer. Mismatched stiffness costs energy instead of converting it into thrust."
      },
      {
        "question": "Which statement best reflects how fin performance actually works?",
        "answers": [
          "A longer or stiffer fin automatically makes a snorkeler faster",
          "Technique and fit to the individual swimmer matter more than blade length or stiffness alone",
          "Only advanced snorkelers need to think about fin fit"
        ],
        "correct_index": 1,
        "explanation": "A stiff or long fin does not fix an inefficient kick. A relaxed, well-controlled swimmer can outperform someone using a more powerful-looking fin badly."
      }
    ]
  },
  "exposure-protection-staying-warm": {
    "questions": [
      {
        "question": "Why is a rash guard useful for snorkeling?",
        "answers": [
          "It can help cover sun-exposed skin and reduce strap chafing while floating face-down",
          "It replaces all need to check water conditions",
          "It makes fins more powerful"
        ],
        "correct_index": 0,
        "explanation": "A rash guard protects areas such as the back, shoulders, and arms from sun, and also reduces rubbing from straps and gear during a long surface swim."
      },
      {
        "question": "About how long before entering the water should sunscreen be applied?",
        "answers": [
          "About 15 minutes, so it has time to bind to skin",
          "Immediately as you enter the water",
          "Timing doesn't matter as long as it's applied at some point"
        ],
        "correct_index": 0,
        "explanation": "Sunscreen needs time to bind to skin. Applied right as you enter the water, much of it can rinse off before it's had a chance to work."
      },
      {
        "question": "What should guide wetsuit thickness choice?",
        "answers": [
          "Water temperature, session length, movement, and personal cold tolerance",
          "Frame color on the mask",
          "Air temperature alone"
        ],
        "correct_index": 0,
        "explanation": "Water temperature and time in the water are usually more relevant than air temperature alone."
      },
      {
        "question": "What does \"snug, not constrictive\" mean for a wetsuit or hood?",
        "answers": [
          "It should limit flushing without restricting breathing, swallowing, circulation, or normal movement",
          "It should feel as tight as possible",
          "It should be loose enough for fresh water to flush through constantly"
        ],
        "correct_index": 0,
        "explanation": "A good fit limits water exchange while still allowing comfortable breathing, movement, and circulation."
      },
      {
        "question": "What is a good care habit for neoprene gear?",
        "answers": [
          "Rinse with fresh water and dry in shade",
          "Store it wet in a closed bag",
          "Dry it next to direct heat"
        ],
        "correct_index": 0,
        "explanation": "Fresh-water rinsing and shaded drying help protect neoprene, seams, and zippers."
      },
      {
        "question": "What's the main defense against coral cuts and jellyfish stings, gear included?",
        "answers": [
          "Good body position and avoiding contact, gear is a backup layer, not a substitute",
          "A rash guard alone guarantees full protection",
          "Neither can be reduced with gear or technique"
        ],
        "correct_index": 0,
        "explanation": "Fabric coverage helps, but it doesn't make contact safe. Coral cuts also carry a real infection risk, which is one more reason avoidance is the priority, not just the pain."
      }
    ]
  },
  "health-readiness-and-personal-responsibility": {
    "questions": [
      {
        "question": "What should you do if you have a medical condition or concern before snorkeling?",
        "answers": [
          "Ignore it if it feels unrelated to swimming",
          "Only worry about it if symptoms appear in the water",
          "Talk to a doctor before snorkeling"
        ],
        "correct_index": 2,
        "explanation": "Conditions that seem minor on land, especially ones affecting breathing or heart health, can become more serious in water, so it is worth checking with a doctor first."
      },
      {
        "question": "What is the purpose of the readiness self-check described in this lesson?",
        "answers": [
          "To give a rough sense of your comfort and competence in open water",
          "To pass a certified swimming exam",
          "To replace the need for a buddy"
        ],
        "correct_index": 0,
        "explanation": "The self-check is a general comfort guide, not a certification, meant to help you honestly judge your own readiness."
      },
      {
        "question": "What does \"personal responsibility\" mean in the context of this lesson?",
        "answers": [
          "Snorkeling without any rules or guidance",
          "Staying alert, checking conditions, and making your own safe decisions in the water",
          "Relying on gear alone to guarantee safety"
        ],
        "correct_index": 1,
        "explanation": "Personal responsibility is about active awareness and honest self-assessment, since snorkeling is often self-directed rather than fully supervised."
      },
      {
        "question": "If you are unsure whether you are comfortable enough in open water to snorkel, what is a practical next step?",
        "answers": [
          "Snorkel anyway and see what happens",
          "Avoid the water permanently",
          "Take swimming lessons to build confidence and comfort first"
        ],
        "correct_index": 2,
        "explanation": "Swimming lessons are a practical, low-risk way to build the comfort and competence snorkeling benefits from."
      }
    ]
  },
  "golden-rules-for-safer-snorkeling": {
    "questions": [
      {
        "question": "What comes first in this briefing, and why?",
        "answers": [
          "Snorkeling with a buddy, because it's the safety net for almost every other risk on the list",
          "Choosing fins, because comfort matters most",
          "Duck diving, because it's the most exciting part"
        ],
        "correct_index": 0,
        "explanation": "A buddy is what turns most other problems on this list from dangerous into survivable, which is why it leads the list."
      },
      {
        "question": "Why should you avoid hyperventilating before a breath-hold or duck dive?",
        "answers": [
          "It delays your urge to breathe without adding meaningful oxygen, raising blackout risk",
          "It has no real effect on breath-hold safety",
          "It guarantees a longer, safer breath-hold"
        ],
        "correct_index": 0,
        "explanation": "Hyperventilation removes the warning signal that normally tells you to surface, which is why blackout can happen with no warning at all."
      },
      {
        "question": "Why is watching for boat traffic part of this briefing?",
        "answers": [
          "Being struck by a vessel is a real, documented risk, not a rare edge case",
          "It has no real bearing on snorkeling safety",
          "Boats can always see snorkelers regardless of visibility"
        ],
        "correct_index": 0,
        "explanation": "DAN specifically names watercraft strikes as a real snorkeling risk, staying in marked areas and watching for boats reduces it."
      },
      {
        "question": "What should you do if peer pressure is pushing you beyond your comfort level?",
        "answers": [
          "Keep going so you do not slow the group down",
          "Stay within your limits",
          "Swim farther away from shore"
        ],
        "correct_index": 1,
        "explanation": "The lesson emphasizes knowing your limits and avoiding stressful or overexerting situations."
      },
      {
        "question": "What should you prepare before snorkeling somewhere remote or unsupervised?",
        "answers": [
          "Tell someone your plan, and keep a phone, emergency numbers, and a first aid kit accessible on land",
          "Nothing extra, a buddy in the water covers everything",
          "Less preparation than usual, since fewer people means fewer risks"
        ],
        "correct_index": 0,
        "explanation": "A buddy is your safety net in the water. A plan, a phone, and first aid are your safety net once you're back on land, especially where help isn't nearby."
      }
    ]
  },
  "surface-safety-devices": {
    "questions": [
      {
        "question": "What is a signaling buoy primarily used for?",
        "answers": [
          "Replacing the need for a mask",
          "Only for scuba diving, not snorkeling",
          "Improving visibility to boats and other snorkelers, and providing extra flotation"
        ],
        "correct_index": 2,
        "explanation": "A signaling buoy makes you more visible and can also serve as a flotation aid if needed."
      },
      {
        "question": "Why is a whistle useful for surface safety?",
        "answers": [
          "Sound travels well over water, making it effective for getting attention",
          "It looks impressive",
          "It replaces the need for a buddy"
        ],
        "correct_index": 0,
        "explanation": "A whistle carries over distance and choppy water more reliably than shouting, making it a simple, effective signal."
      },
      {
        "question": "Who benefits from wearing a life jacket while snorkeling?",
        "answers": [
          "Only very weak swimmers",
          "Weaker swimmers and anyone wanting extra buoyancy or reduced effort in challenging conditions",
          "No one, since masks provide enough flotation"
        ],
        "correct_index": 1,
        "explanation": "A life jacket is useful beyond just weak swimmers, it adds a safety margin any time conditions or fatigue are a concern."
      },
      {
        "question": "What should guide your decision about which surface safety devices to bring?",
        "answers": [
          "Always bring every device regardless of conditions",
          "Never bring any device unless required by law",
          "The specific conditions and swimmer ability for that outing"
        ],
        "correct_index": 2,
        "explanation": "Boat traffic, open water, and swimmer confidence all affect which devices are actually useful for a given session."
      },
      {
        "question": "Is carrying a signaling buoy always just a personal preference?",
        "answers": [
          "Yes, it's always optional everywhere",
          "No, some places legally require one, Florida is one example, for anyone snorkeling with a mask and snorkel",
          "No, it's only required for scuba divers, never snorkelers"
        ],
        "correct_index": 1,
        "explanation": "In Florida, a diver-down flag or buoy is legally required for snorkelers too, not just scuba divers, with boats required to stay a set distance away. Requirements vary by location, so it's worth checking before you assume it's optional."
      }
    ]
  },
  "pre-snorkel-checklist-and-planning": {
    "questions": [
      {
        "question": "What should you do if your mask has a cracked lens during a pre-snorkel gear check?",
        "answers": [
          "Ignore it if the crack is small",
          "Fix it after your snorkel session",
          "Address it before entering the water"
        ],
        "correct_index": 2,
        "explanation": "A gear problem found on land is much easier and safer to address than one discovered once you are already in the water."
      },
      {
        "question": "When should you plan your entry and exit points?",
        "answers": [
          "Before you enter the water",
          "While you are already swimming",
          "Only if the water looks rough"
        ],
        "correct_index": 0,
        "explanation": "Planning entry and exit points ahead of time avoids scrambling to find a safe way in or out once you are already committed."
      },
      {
        "question": "What should you do if conditions look worse than expected when you arrive?",
        "answers": [
          "Snorkel anyway since you already made the trip",
          "Consider cancelling or postponing",
          "Only worry about it once you're in the water"
        ],
        "correct_index": 1,
        "explanation": "Good planning includes being willing to change your plans when conditions do not match expectations."
      },
      {
        "question": "Why tie back long hair before snorkeling?",
        "answers": [
          "It has no real effect on your session",
          "It only matters for freediving",
          "Hair under the mask seal can break the seal and cause leaks"
        ],
        "correct_index": 2,
        "explanation": "Loose hair caught under the skirt seal is a common, avoidable cause of mask leaks."
      }
    ]
  },
  "beach-flags-and-surface-warnings": {
    "questions": [
      {
        "question": "Are beach flag colors and meanings the same everywhere in the world?",
        "answers": [
          "Yes, they are fully standardized worldwide",
          "No, they vary by region, country, and even beach authority",
          "Only red and yellow flags are used anywhere"
        ],
        "correct_index": 1,
        "explanation": "Flag systems differ by country, region, state, and individual beach, so meanings should always be confirmed locally."
      },
      {
        "question": "What should you do if you see a flag you don't recognize?",
        "answers": [
          "Guess based on common conventions and enter the water",
          "Ignore it since flags are usually decorative",
          "Ask a lifeguard, staff member, resort, or local authority what it means"
        ],
        "correct_index": 2,
        "explanation": "Asking someone with local knowledge avoids the risk of misunderstanding a warning that may not match conventions you've seen elsewhere."
      },
      {
        "question": "In the USLA's official US system, what does a yellow flag with a black ball mean?",
        "answers": [
          "Surfboards and other non-powered watercraft are prohibited",
          "A recommended swimming area",
          "Marine pests are present"
        ],
        "correct_index": 0,
        "explanation": "This flag specifically marks an area where watercraft use is not allowed, distinct from the general watercraft-area flag (black and white checkered)."
      },
      {
        "question": "Does a single international beach flag system exist?",
        "answers": [
          "Yes, it's managed globally by one organization",
          "No, even the International Life Saving Federation confirms no unified global system exists",
          "Yes, but only in Europe"
        ],
        "correct_index": 1,
        "explanation": "The ILS, the closest thing to a global authority on this, states directly that no unified system exists, and even the most common flag isn't accepted everywhere."
      },
      {
        "question": "If no one is available to explain an unfamiliar warning and you're unsure what it means, what's the safest choice?",
        "answers": [
          "Enter the water and adjust if there's a problem",
          "Assume it doesn't apply to snorkelers",
          "Avoid entering the water until you know more"
        ],
        "correct_index": 2,
        "explanation": "Treating an unclear warning conservatively is safer than guessing, especially with no one available to confirm its meaning."
      }
    ]
  },
  "currents-and-rip-currents": {
    "questions": [
      {
        "question": "What is a current?",
        "answers": [
          "A wave breaking on shore",
          "A stream of water moving in a consistent direction",
          "A type of coral reef"
        ],
        "correct_index": 1,
        "explanation": "A current is moving water with direction."
      },
      {
        "question": "Which current flows parallel to shore?",
        "answers": [
          "Rip current",
          "Surface warning",
          "Longshore current"
        ],
        "correct_index": 2,
        "explanation": "Longshore currents move along the coastline."
      },
      {
        "question": "Which current moves directly away from shore?",
        "answers": [
          "Rip current",
          "Tidal current only",
          "Longshore current"
        ],
        "correct_index": 0,
        "explanation": "Rip currents are narrow currents that move away from shore."
      },
      {
        "question": "Why can a longshore current matter to a snorkeler?",
        "answers": [
          "It changes mask skirt color",
          "It can move the snorkeler along the shore and affect entry or exit points",
          "It only matters in deep ocean crossings"
        ],
        "correct_index": 1,
        "explanation": "Lateral water movement can change where a snorkeler ends up relative to the planned entry and exit."
      },
      {
        "question": "What's a visual sign that may indicate a rip current?",
        "answers": [
          "Perfectly clear, still water",
          "Waves breaking evenly across the whole beach",
          "A channel where waves aren't breaking, or foam or discolored water moving steadily seaward"
        ],
        "correct_index": 2,
        "explanation": "Rip currents often show up as a gap in the breaking wave pattern, or debris and foam being pulled out past the surf line."
      },
      {
        "question": "What should you do if you're caught in a current moving you away from shore?",
        "answers": [
          "Stay afloat, don't fight it, and swim parallel to shore until you're free of it",
          "Swim as hard as possible straight back toward shore",
          "Dive underwater to escape it faster"
        ],
        "correct_index": 0,
        "explanation": "Fighting a rip current head-on wastes energy. Swimming parallel to shore gets you out of the current, which does not pull you under, only out."
      },
      {
        "question": "Why is slack tide often recommended for snorkeling in channels or near points?",
        "answers": [
          "It guarantees the clearest water regardless of location",
          "It's the window when water movement, and current risk, is at its weakest",
          "It only matters for scuba diving, not snorkeling"
        ],
        "correct_index": 1,
        "explanation": "Slack tide is about minimal water movement, not visibility or depth, which is why it matters most in places where currents are otherwise strong."
      }
    ]
  },
  "waves-tides-and-surge": {
    "questions": [
      {
        "question": "What primarily causes waves?",
        "answers": [
          "The gravitational pull of the moon",
          "Underwater earthquakes",
          "Wind interacting with the water's surface"
        ],
        "correct_index": 2,
        "explanation": "Waves are disturbances driven by wind, with their size depending on wind speed, duration, and distance traveled over water."
      },
      {
        "question": "What are tides?",
        "answers": [
          "The regular rise and fall of sea level from gravitational forces",
          "Water movement caused entirely by wind",
          "A type of current found only near reefs"
        ],
        "correct_index": 0,
        "explanation": "Tides are caused by the gravitational pull of the moon and sun, producing a regular pattern of rising and falling sea level."
      },
      {
        "question": "Why does surge deserve extra caution near rocks or reefs?",
        "answers": [
          "Surge only occurs near rocks",
          "Being pushed and pulled repeatedly in a confined space raises injury risk",
          "Surge is always stronger over open sand"
        ],
        "correct_index": 1,
        "explanation": "Surge near rocks or reefs can repeatedly push and pull a snorkeler in a tight space, increasing the chance of injury or getting caught."
      },
      {
        "question": "Why is checking a tide table useful before snorkeling?",
        "answers": [
          "It tells you the water temperature",
          "It predicts wave height precisely",
          "It helps you anticipate changes in depth and current strength during your outing"
        ],
        "correct_index": 2,
        "explanation": "Tides change water depth and can affect current strength, so knowing the tide schedule helps you plan entry, exit, and timing."
      },
      {
        "question": "What's the safest way to time an entry through breaking waves?",
        "answers": [
          "Watch for the set-and-lull pattern and enter during the lull",
          "Push through as soon as you're ready, regardless of the wave pattern",
          "Waves don't come in a predictable pattern, so timing doesn't matter"
        ],
        "correct_index": 0,
        "explanation": "Waves usually arrive in sets followed by calmer lulls. Watching the pattern for a few minutes and entering during a lull is safer than pushing through a breaking set."
      },
      {
        "question": "What's the right way to handle surge near rocks or reef?",
        "answers": [
          "Fight against it with continuous hard swimming",
          "Work with it, holding on during the pull and moving with the push, timing critical moves for the calm window",
          "Surge near rocks isn't something you can do anything about"
        ],
        "correct_index": 1,
        "explanation": "Fighting surge wastes energy and increases injury risk. Timing your movement with it, and using something to hold onto, is safer and more effective."
      },
      {
        "question": "Does this lesson cover rip currents and longshore currents?",
        "answers": [
          "Yes, in full detail",
          "Only briefly, with no cross-reference",
          "No, those are covered in a separate lesson on currents"
        ],
        "correct_index": 2,
        "explanation": "Current-driven hazards are covered separately in Currents & Rip Currents, this lesson focuses on waves, tides, and surge."
      }
    ]
  },
  "buddy-communication-and-awareness": {
    "questions": [
      {
        "question": "Why does the buddy system matter in snorkeling?",
        "answers": [
          "It is required by law everywhere",
          "A buddy can notice signs of trouble and help or get assistance quickly",
          "It replaces the need for any other safety preparation"
        ],
        "correct_index": 1,
        "explanation": "A buddy who is paying attention can catch problems early and respond quickly, which is the core value of the system."
      },
      {
        "question": "When should you agree on communication signals with your buddy?",
        "answers": [
          "Before you enter the water",
          "Only if something goes wrong",
          "Signals are not necessary if you know your buddy well"
        ],
        "correct_index": 0,
        "explanation": "Agreeing on signals before entering means both people already know what to expect if they need to communicate."
      },
      {
        "question": "Why should you avoid using thumbs up or thumbs down as a general \"I'm okay\" check?",
        "answers": [
          "They're too hard to see clearly underwater",
          "They are only used by scuba divers, never by snorkelers",
          "In standard diving convention they specifically mean \"ascend\" and \"descend,\" not a status check"
        ],
        "correct_index": 2,
        "explanation": "Using thumbs up or down as a casual good/bad signal risks being read as an instruction to ascend or descend, especially by a buddy trained in diving convention. The OK circle doesn't carry that ambiguity."
      },
      {
        "question": "What does good buddy awareness look like during a session?",
        "answers": [
          "Checking in only at the start and end",
          "Periodically checking in and noticing if your buddy seems to be struggling",
          "Staying nearby without paying attention"
        ],
        "correct_index": 1,
        "explanation": "Ongoing attention, not just occasional check-ins, is what lets a buddy actually catch a developing problem."
      }
    ]
  },
  "breath-hold-safety-co2-and-shallow-water-blackout": {
    "questions": [
      {
        "question": "What mainly triggers the urge to breathe?",
        "answers": [
          "Rising carbon dioxide (CO2) levels",
          "Falling oxygen levels",
          "Water pressure on the chest"
        ],
        "correct_index": 0,
        "explanation": "The urge to breathe is driven mostly by rising CO2 in the bloodstream, which typically happens well before oxygen runs critically low."
      },
      {
        "question": "Why is intentionally hyperventilating before a dive unsafe?",
        "answers": [
          "It increases the amount of oxygen available underwater",
          "It has no real effect on breath-hold safety",
          "It delays the urge to breathe without changing how much oxygen is actually available"
        ],
        "correct_index": 2,
        "explanation": "Hyperventilating lowers CO2 levels, which delays the natural warning signal to breathe, even though oxygen is still being used up at the same rate underwater."
      },
      {
        "question": "What makes shallow-water blackouts particularly dangerous?",
        "answers": [
          "It only happens in deep water",
          "It can cause sudden loss of consciousness with little or no warning",
          "It only affects inexperienced snorkelers"
        ],
        "correct_index": 1,
        "explanation": "Shallow-water blackout can occur suddenly, often without the snorkeler noticing clear warning signs beforehand, which is part of why it's so dangerous."
      },
      {
        "question": "What should you do if you feel a strong urge to breathe while underwater?",
        "answers": [
          "Push through it since the urge is often premature",
          "Hold as still as possible and wait it out",
          "Surface calmly rather than trying to extend the breath-hold further"
        ],
        "correct_index": 2,
        "explanation": "The urge to breathe is a safety signal. Surfacing calmly when you feel it is safer than trying to override or outlast it."
      },
      {
        "question": "Why should you avoid making repeated breath-hold attempts back-to-back?",
        "answers": [
          "This pattern is connected to real breath-hold safety incidents",
          "It has no connection to safety, only comfort",
          "It's fine as long as a buddy is present"
        ],
        "correct_index": 0,
        "explanation": "Repeated breath-hold attempts, especially when trying to beat a previous time, are a recognized risk pattern for breath-hold safety incidents, regardless of buddy presence."
      },
      {
        "question": "Why is the final stretch of ascent, and the moment right after surfacing, the highest-risk window for shallow-water blackout?",
        "answers": [
          "Water temperature drops sharply near the surface",
          "Ambient pressure drops as you ascend, which speeds up the fall in available oxygen right when reserves are already lowest",
          "Currents are always strongest near the surface"
        ],
        "correct_index": 1,
        "explanation": "As you rise, the drop in ambient pressure accelerates the decline in available oxygen at exactly the point your reserves are most depleted, which is why surfacing calmly and early matters more than it might seem."
      }
    ]
  },
  "snorkeling-emergencies-recognition-and-preparedness": {
    "questions": [
      {
        "question": "What is this lesson intended to teach?",
        "answers": [
          "Full first-aid and CPR procedures",
          "Advanced rescue diving techniques",
          "How to recognize a developing emergency and get help quickly"
        ],
        "correct_index": 2,
        "explanation": "This lesson focuses on recognition and preparedness, explicitly directing learners toward formal training for procedural first aid and CPR."
      },
      {
        "question": "Which of these is a sign that something may be wrong with a snorkeler?",
        "answers": [
          "Disorientation, unusual fatigue, or trouble staying afloat",
          "Swimming steadily toward shore",
          "Adjusting their mask underwater"
        ],
        "correct_index": 0,
        "explanation": "Disorientation, unusual fatigue, and trouble staying afloat are all signs that something may be wrong and worth taking seriously."
      },
      {
        "question": "What does \"reach, throw, don't go\" mean in this context?",
        "answers": [
          "Always swim out to help immediately",
          "Try to help without entering the water yourself first, if possible",
          "Ignore the situation until a lifeguard arrives"
        ],
        "correct_index": 1,
        "explanation": "Helping with a reach or a thrown flotation device, rather than an untrained swimming rescue, reduces the risk of you becoming a second casualty."
      },
      {
        "question": "What should you do immediately after noticing a concerning sign in a buddy?",
        "answers": [
          "Wait to see if it resolves on its own",
          "Continue snorkeling and check on them later",
          "Signal for help right away"
        ],
        "correct_index": 2,
        "explanation": "Acting quickly, by signaling for help, gives responders the best chance to reach the person in time."
      },
      {
        "question": "Does this lesson replace a formal first-aid and CPR course?",
        "answers": [
          "No, it's awareness-level only and recommends taking a real course",
          "Yes, it covers everything needed",
          "Only for basic situations, not serious ones"
        ],
        "correct_index": 0,
        "explanation": "This lesson is explicitly awareness-level and recommends a recognized first-aid and CPR course for anyone who wants procedural training."
      },
      {
        "question": "What does real drowning often look like, compared to what most people expect?",
        "answers": [
          "Loud splashing and shouting for help",
          "Quiet and upright in the water, unable to call out or wave",
          "Exactly like an exhausted swimmer calmly resting on their back"
        ],
        "correct_index": 1,
        "explanation": "Real drowning is usually silent. The person is often vertical in the water with their head tilted back, unable to wave or call out, which is why it's easy for a bystander to miss if they're only watching for loud struggling."
      }
    ]
  },
  "entry-and-exit-techniques": {
    "questions": [
      {
        "question": "When wading into the water from a shallow shore, when should you put your fins on?",
        "answers": [
          "While seated, after wading in far enough to sit comfortably",
          "While standing at the water's edge",
          "Only after you start swimming"
        ],
        "correct_index": 0,
        "explanation": "Putting fins on while seated is more stable and controlled than trying to balance on one foot at the water's edge."
      },
      {
        "question": "What is the recommended way to step into deep water during a deep-water entry?",
        "answers": [
          "Jump or hop in for a big splash",
          "Run and dive in headfirst",
          "Step forward deliberately, holding your mask and strap in place"
        ],
        "correct_index": 2,
        "explanation": "A deliberate step reduces the risk of slipping, losing your mask, or landing awkwardly on an uneven or slippery edge."
      },
      {
        "question": "Why should you remove your fins one at a time before climbing a boat ladder?",
        "answers": [
          "It's a tradition with no real safety purpose",
          "Fins make climbing a ladder difficult and unsafe",
          "Fins are not allowed on boats"
        ],
        "correct_index": 1,
        "explanation": "Fins make it hard to get a secure footing on ladder rungs, so removing them first makes the climb safer."
      },
      {
        "question": "What should you do if conditions are choppy during a shore exit?",
        "answers": [
          "Turn your back to the ocean and walk straight out",
          "Swim as fast as possible to the shore",
          "Face the ocean and walk backward slowly, pausing as waves come in"
        ],
        "correct_index": 2,
        "explanation": "Facing the ocean lets you see and react to incoming waves rather than being caught off guard from behind."
      },
      {
        "question": "What should you do before stepping into deep water from a dock or rocky edge?",
        "answers": [
          "Assume it's fine since others have used the spot before",
          "Look at the water ahead and below to confirm it's clear and deep enough",
          "Enter as quickly as possible to get it over with"
        ],
        "correct_index": 1,
        "explanation": "Depth and visibility right at an entry point can vary a lot, especially around rocks, checking before you step in is the difference between a clean entry and stepping onto something you didn't see."
      },
      {
        "question": "Why should you shuffle your feet rather than step down cleanly when wading over a sandy bottom?",
        "answers": [
          "It gives a stingray buried in the sand a chance to move away before you step on it",
          "It's faster than walking normally",
          "It helps you spot fish more easily"
        ],
        "correct_index": 0,
        "explanation": "Shuffling reduces the chance of stepping directly on a ray, which is how most stingray injuries actually happen."
      }
    ]
  },
  "clearing-your-snorkel": {
    "questions": [
      {
        "question": "What is the \"blast method\" for clearing a snorkel?",
        "answers": [
          "Removing the snorkel from your mouth entirely",
          "Inhaling deeply until the water clears itself",
          "A sharp, forceful exhale through the mouth to push water out"
        ],
        "correct_index": 2,
        "explanation": "A forceful, sharp exhale generates enough pressure to push water out through the top of the tube."
      },
      {
        "question": "How does a purge valve change the clearing process?",
        "answers": [
          "It lets water drain from the bottom, usually reducing the effort needed",
          "It removes the need to exhale entirely",
          "It has no effect on clearing"
        ],
        "correct_index": 0,
        "explanation": "A purge valve gives water an exit point near the mouthpiece, which usually means less force is needed compared to a full blast to the top."
      },
      {
        "question": "What should you do if you feel panicked after water enters your snorkel?",
        "answers": [
          "Keep swimming and ignore it",
          "Surface, lift your head above water, and breathe normally before continuing",
          "Remove your mask immediately"
        ],
        "correct_index": 1,
        "explanation": "Surfacing to breathe normally is a simple way to reset if clearing the snorkel feels stressful in the moment."
      },
      {
        "question": "Why is a gentle exhale usually not enough to clear a snorkel?",
        "answers": [
          "Gentle exhales work better than forceful ones",
          "The exhale strength doesn't matter at all",
          "It doesn't generate enough force to push the water out"
        ],
        "correct_index": 2,
        "explanation": "Clearing water requires enough air pressure to push it out of the tube, which a slow, gentle breath typically cannot generate."
      }
    ]
  },
  "duck-diving-basics": {
    "questions": [
      {
        "question": "What drives the initial descent in a duck dive?",
        "answers": [
          "Bending at the hips and lifting the legs out of the water",
          "Kicking hard from a horizontal position",
          "Pulling yourself down with your arms"
        ],
        "correct_index": 0,
        "explanation": "Bending at the hips and lifting the legs, using their weight, is what drives the body downward to start the dive."
      },
      {
        "question": "What kind of breath should you take before duck diving?",
        "answers": [
          "Several rapid breaths in a row",
          "A forced, extra-deep breath to maximize dive time",
          "A normal, relaxed breath"
        ],
        "correct_index": 2,
        "explanation": "A normal, relaxed breath is safer than a forced or extended one, which connects to the breath-hold safety principles covered separately."
      },
      {
        "question": "Why is it a good habit for buddy pairs to alternate duck dives?",
        "answers": [
          "It's required by all dive operators",
          "It keeps one person watching from the surface while the other descends",
          "It makes the dive faster"
        ],
        "correct_index": 1,
        "explanation": "Alternating means someone is always watching from the surface, which supports quicker help if something goes wrong, including in the moments right after the diver resurfaces."
      },
      {
        "question": "What should you do immediately after surfacing from a duck dive?",
        "answers": [
          "Clear your snorkel if needed and breathe normally before diving again",
          "Attempt another dive right away to make the most of the outing",
          "Remove your mask and rest on your back"
        ],
        "correct_index": 0,
        "explanation": "Clearing your airway and breathing normally before attempting another dive gives your body time to recover."
      },
      {
        "question": "Why should you look up and check what's above you before finishing your ascent from a duck dive?",
        "answers": [
          "It's only a concern in areas without lifeguards",
          "Ascending is naturally slower than descending, so timing doesn't matter",
          "You've been focused on the dive and may not have seen surface traffic, like a boat, that's now a collision risk as you surface"
        ],
        "correct_index": 2,
        "explanation": "Checking your surroundings and keeping a hand raised as you ascend helps you spot and avoid boats or other hazards you couldn't see while your attention was underwater, this matters most where there's real boat traffic."
      }
    ]
  },
  "mask-clearing-techniques": {
    "questions": [
      {
        "question": "What do all three mask-clearing methods have in common?",
        "answers": [
          "They all require removing the mask first",
          "They only work with a snorkel attached",
          "They all use the same breathing and head-tilt technique, with different hand positions"
        ],
        "correct_index": 2,
        "explanation": "The hand position changes between methods, but the core technique, breathing in through the mouth and exhaling through the nose while looking up, stays the same."
      },
      {
        "question": "In the one-hand tilt method, what does the thumb do?",
        "answers": [
          "Gently pulls the bottom seal away from the face slightly",
          "Presses firmly on the top frame",
          "Nothing, only the index finger is used"
        ],
        "correct_index": 0,
        "explanation": "The thumb creates a small gap at the bottom seal, which helps water drain out during the exhale."
      },
      {
        "question": "Why is a continuous exhale through the nose important when clearing a mask?",
        "answers": [
          "A short puff of air is usually enough",
          "A continuous exhale generates enough airflow to fully push the water out",
          "It has no effect on clearing the mask"
        ],
        "correct_index": 1,
        "explanation": "A brief puff often isn't enough, a sustained exhale is what fully clears the water from the mask."
      },
      {
        "question": "What should you do if water doesn't fully clear on your first try?",
        "answers": [
          "Remove the mask and start over",
          "Continue snorkeling with water still in the mask",
          "Repeat the exhale using the same technique"
        ],
        "correct_index": 2,
        "explanation": "Repeating the exhale is a normal part of the process if the mask isn't fully clear the first time."
      },
      {
        "question": "Why should you never inhale through your nose while clearing your mask?",
        "answers": [
          "If water is still in the mask, you risk pulling it up into your nose",
          "It wastes air you need for the exhale",
          "It has no real effect either way"
        ],
        "correct_index": 0,
        "explanation": "Water still sitting in the mask can get drawn up into your nose if you inhale there instead of through your mouth, uncomfortable at best, and a good way to startle yourself into panic over a normal, fixable situation."
      },
      {
        "question": "Why should you only lift the bottom seal a hair's breadth with the One-Hand Tilt method?",
        "answers": [
          "Lifting it further doesn't make any real difference either way",
          "Lifting it further risks letting in more water than it clears",
          "It's required to activate the mask's purge valve"
        ],
        "correct_index": 1,
        "explanation": "The One-Hand Tilt still relies on the top seal holding firm while your exhale pushes water out a small gap at the bottom. Opening that gap too wide works against the technique instead of helping it, whether you're at the surface or underwater."
      }
    ]
  },
  "efficient-kicking-techniques": {
    "questions": [
      {
        "question": "Which kick style is generally considered the best choice for minimizing disturbance near coral?",
        "answers": [
          "Straight-leg/flutter kick",
          "Modified flutter kick",
          "Frog kick"
        ],
        "correct_index": 2,
        "explanation": "The frog kick's controlled, outward-and-back motion creates the least disturbance, making it the best choice near coral and reef structures."
      },
      {
        "question": "What's a common efficiency mistake with the straight-leg/flutter kick and frog kick specifically?",
        "answers": [
          "Kicking from the knees instead of driving the motion from the hips",
          "Kicking from the hips instead of the knees",
          "Pointing the toes"
        ],
        "correct_index": 0,
        "explanation": "Both the straight-leg/flutter kick and frog kick rely on power from the hips, kicking mainly from the knee wastes energy and causes early fatigue. The modified flutter kick is the exception, it's deliberately driven more from the knee and lower leg to keep the motion small."
      },
      {
        "question": "When is the straight-leg/flutter kick most useful?",
        "answers": [
          "When maneuvering in tight spaces near coral",
          "When you need maximum speed for a short burst",
          "When you want efficient, sustained movement over distance"
        ],
        "correct_index": 2,
        "explanation": "The straight-leg/flutter kick favors sustained, efficient propulsion over distance rather than short bursts of speed."
      },
      {
        "question": "What should guide your choice of kick style during a snorkel?",
        "answers": [
          "Always use the same kick regardless of conditions",
          "The situation, such as proximity to coral or the distance you need to cover",
          "Whichever kick feels fastest at all times"
        ],
        "correct_index": 1,
        "explanation": "Switching kick styles based on the situation, like using the frog kick near coral, is a normal part of efficient, responsible snorkeling."
      },
      {
        "question": "Why might you use the modified flutter kick instead of the frog kick near coral?",
        "answers": [
          "It's a similar low-disturbance option that's easier to learn than the frog kick",
          "It's faster than the frog kick in every situation",
          "It's required by law in protected marine areas"
        ],
        "correct_index": 0,
        "explanation": "The modified flutter kick isn't a replacement for a well-executed frog kick, but it's a smaller, easier-to-learn version of the straight-leg/flutter kick that still reduces disturbance, a good option while you're still building frog kick technique."
      }
    ]
  },
  "relaxed-breathing-and-efficient-movement": {
    "questions": [
      {
        "question": "What should provide most of your propulsion while snorkeling?",
        "answers": [
          "Your arms, paddling at your sides",
          "Your snorkel",
          "Your fins and legs"
        ],
        "correct_index": 2,
        "explanation": "Efficient snorkeling relies mainly on the legs and fins for propulsion, with the arms staying relaxed rather than paddling."
      },
      {
        "question": "What's a good response if you notice your breathing speeding up while snorkeling?",
        "answers": [
          "Slow down, relax your shoulders, and let your breathing settle",
          "Kick harder to get back to shore faster",
          "Hold your breath briefly to reset"
        ],
        "correct_index": 0,
        "explanation": "Slowing down and relaxing helps breathing settle back into a calm, even rhythm, which reduces both anxiety and energy use."
      },
      {
        "question": "If you're getting tired quickly while snorkeling, what does this lesson suggest?",
        "answers": [
          "Kick harder to push through the fatigue",
          "Switch to breathing through your mouth only",
          "Slow down and focus on a streamlined position"
        ],
        "correct_index": 2,
        "explanation": "Quick fatigue is often a sign to slow down and streamline your body position rather than to increase effort."
      },
      {
        "question": "Why does relaxed breathing matter beyond general comfort?",
        "answers": [
          "It only matters for advanced snorkelers",
          "It connects to breath-hold safety and calm, controlled duck diving",
          "It has no connection to other snorkeling skills"
        ],
        "correct_index": 1,
        "explanation": "Staying calm and breathing steadily is part of the foundation for breath-hold safety and for controlled, unhurried duck diving."
      }
    ]
  },
  "floating-and-treading-water": {
    "questions": [
      {
        "question": "What helps you float more easily on your back?",
        "answers": [
          "Taking short, shallow breaths",
          "Tensing your muscles to stay rigid",
          "Taking full breaths and relaxing your body"
        ],
        "correct_index": 2,
        "explanation": "A full breath increases buoyancy, and a relaxed body floats more easily than a tense one."
      },
      {
        "question": "What is the basic leg motion used for treading water?",
        "answers": [
          "A downward frog-kick motion",
          "Kicking as hard and fast as possible",
          "A flutter kick"
        ],
        "correct_index": 0,
        "explanation": "A downward frog-kick, pushing out and then bringing the legs back together, is the basic motion used to stay upright while treading water."
      },
      {
        "question": "Why do small, controlled movements work better than large, forceful ones for both floating and treading water?",
        "answers": [
          "They look better",
          "They conserve more energy over time",
          "They are required by safety guidelines"
        ],
        "correct_index": 1,
        "explanation": "Large, forceful movements burn energy quickly without adding much benefit, while small, controlled movements are more sustainable."
      },
      {
        "question": "What should you do if you get tired while treading water?",
        "answers": [
          "Kick harder to power through the fatigue",
          "Hold your breath and stay still",
          "Roll onto your back and float for a moment"
        ],
        "correct_index": 2,
        "explanation": "Rolling onto your back to float lets you rest and recover before resuming treading water, conserving energy."
      },
      {
        "question": "Why do many people start to sink while trying to float on their back?",
        "answers": [
          "They let their exhale go all the way empty before breathing in again",
          "They are holding too much air in their lungs",
          "Their body type makes floating impossible for them"
        ],
        "correct_index": 0,
        "explanation": "Fully emptying your lungs is what usually causes sinking, not a lack of skill, keeping some air in your lungs at all times helps maintain buoyancy."
      },
      {
        "question": "What's a benefit of the eggbeater kick over the basic frog-kick style, once you've practiced it?",
        "answers": [
          "It requires less hip flexibility to learn",
          "It frees up your hands completely, since the legs do all the work",
          "It uses less energy than every other technique"
        ],
        "correct_index": 1,
        "explanation": "The eggbeater kick is preferred by lifeguards and water polo players because it lets you use your hands for other tasks while treading water, though it takes more practice and hip flexibility to learn than the frog-kick style."
      }
    ]
  },
  "buoyancy-pressure-and-airspaces": {
    "questions": [
      {
        "question": "What causes buoyancy?",
        "answers": [
          "An upward force equal to the weight of water displaced by your body",
          "Water temperature",
          "The color of the water"
        ],
        "correct_index": 0,
        "explanation": "Buoyancy comes from the water pushing back with a force equal to the weight of the water your body displaces."
      },
      {
        "question": "Why does saltwater generally make floating easier than freshwater?",
        "answers": [
          "Saltwater is warmer",
          "Saltwater has less pressure",
          "Saltwater is denser, providing slightly more buoyant force"
        ],
        "correct_index": 2,
        "explanation": "Saltwater's higher density means it produces slightly more buoyant force than freshwater, making floating a bit easier."
      },
      {
        "question": "What happens to air spaces in your body as you descend?",
        "answers": [
          "They compress under increasing pressure",
          "They expand",
          "They stay exactly the same"
        ],
        "correct_index": 0,
        "explanation": "As pressure increases with depth, air spaces like the sinuses and middle ear compress, which is why equalizing is necessary."
      },
      {
        "question": "Why is understanding airspaces relevant before duck diving?",
        "answers": [
          "It has no real connection to duck diving",
          "It explains why equalizing technique exists and matters",
          "It only matters for scuba diving, not snorkeling"
        ],
        "correct_index": 1,
        "explanation": "Airspace compression under pressure is the direct reason equalizing techniques exist, and duck diving is where a snorkeler is most likely to need them."
      }
    ]
  },
  "light-vision-and-sound-underwater": {
    "questions": [
      {
        "question": "Why do colors like red and orange fade first as depth increases?",
        "answers": [
          "They only exist near the surface",
          "They are absorbed by water more than other wavelengths",
          "Fish eat the color out of the water"
        ],
        "correct_index": 1,
        "explanation": "Different wavelengths of light are absorbed at different rates in water, and warm colors like red are absorbed first, even at shallow depths."
      },
      {
        "question": "Why do objects appear larger and closer underwater through a mask?",
        "answers": [
          "Because your eyes adjust permanently to underwater vision",
          "Because water always magnifies everything equally at any depth",
          "Because of refraction caused by the air pocket in front of your eyes"
        ],
        "correct_index": 2,
        "explanation": "Light bends as it passes from water into the air pocket inside your mask, making objects appear larger and closer than they actually are."
      },
      {
        "question": "How does sound behave differently underwater compared to air?",
        "answers": [
          "It travels faster but is harder to localize by direction",
          "It travels slower and is easier to localize",
          "It doesn't travel through water at all"
        ],
        "correct_index": 0,
        "explanation": "Sound travels roughly four times faster underwater, which paradoxically makes it harder to tell which direction it's coming from."
      },
      {
        "question": "Why is it useful to know these light and sound effects before snorkeling?",
        "answers": [
          "They only matter for professional divers",
          "They help you interpret what you're experiencing rather than assuming something is wrong",
          "They change how buoyancy works"
        ],
        "correct_index": 1,
        "explanation": "Understanding these normal effects helps you make sense of what you see and hear underwater, rather than mistaking them for gear problems."
      }
    ]
  },
  "equalizing-basics": {
    "questions": [
      {
        "question": "Why does equalizing matter when you dive below the surface?",
        "answers": [
          "It relieves pressure building in your ears and sinuses",
          "It helps you swim faster",
          "It improves your underwater vision"
        ],
        "correct_index": 0,
        "explanation": "As you descend, pressure builds on airspaces like your ears and sinuses, and equalizing relieves that pressure to prevent discomfort or injury."
      },
      {
        "question": "When should you start equalizing?",
        "answers": [
          "Only once you feel pain",
          "Only after reaching your deepest point",
          "Early, at the first sign of pressure, and repeated often"
        ],
        "correct_index": 2,
        "explanation": "Equalizing early and often is more comfortable and safer than waiting until pressure becomes painful."
      },
      {
        "question": "What should you do if you're having difficulty equalizing?",
        "answers": [
          "Ascend slightly and try again",
          "Force it harder to get it to work",
          "Continue descending and try again at the bottom"
        ],
        "correct_index": 0,
        "explanation": "Difficulty equalizing is a sign to ease off, ascend a little, and try again rather than pushing further down or forcing it."
      },
      {
        "question": "What does the Frenzel maneuver involve?",
        "answers": [
          "Blowing forcefully through a pinched nose",
          "Making a \"K\" sound while pinching the nose",
          "Wiggling the jaw with your mouth closed"
        ],
        "correct_index": 1,
        "explanation": "The Frenzel maneuver involves pinching the nose and making a \"K\" sound while trying to push air through the nose, offering a more controlled alternative to the Valsalva maneuver."
      },
      {
        "question": "What sensation should equalizing produce if done correctly?",
        "answers": [
          "Sharp pain in one ear",
          "No sensation at all",
          "Gentle relief in both ears"
        ],
        "correct_index": 2,
        "explanation": "A correctly performed equalization should bring gentle relief in both ears, not strain, pain, or a total absence of sensation."
      },
      {
        "question": "If the Valsalva maneuver isn't relieving pressure, what's the safest next step?",
        "answers": [
          "Blow harder and hold it longer to force the tube open",
          "Stop descending, ascend slightly, then try again gently or use another method",
          "Keep descending, it usually resolves itself lower down"
        ],
        "correct_index": 1,
        "explanation": "If a gentle Valsalva isn't working, stop the descent and ascend slightly to reduce the pressure difference. Then try again gently or use another method rather than forcing it harder."
      }
    ]
  },
  "why-you-get-cold-in-water": {
    "questions": [
      {
        "question": "Why can you feel cold snorkeling in water that wouldn't feel cold as air temperature?",
        "answers": [
          "Water always contains less oxygen than air",
          "Wetsuits trap cold water against your skin",
          "Water conducts heat away from your body much more efficiently than air"
        ],
        "correct_index": 2,
        "explanation": "Water draws heat away from the body roughly 20 to 27 times faster than air, so the same temperature feels colder in water than in air."
      },
      {
        "question": "What is a sign that your body is struggling to stay warm?",
        "answers": [
          "Shivering, clumsiness, or unusual tiredness",
          "Feeling thirsty",
          "Feeling comfortable and relaxed"
        ],
        "correct_index": 0,
        "explanation": "Shivering, clumsiness, and unusual tiredness are signs the body is working hard to maintain warmth, and it's time to exit and warm up."
      },
      {
        "question": "Can overheating happen while snorkeling?",
        "answers": [
          "No, only cold-water risk exists",
          "Only during scuba diving, not snorkeling",
          "Yes, especially in warm water while wearing a wetsuit"
        ],
        "correct_index": 2,
        "explanation": "Warm water combined with a wetsuit and sun exposure can lead to overheating, which is why hydration and shade breaks matter too."
      },
      {
        "question": "How does this lesson connect to choosing exposure gear?",
        "answers": [
          "It has no real connection to gear choice",
          "It explains the physiology behind why the right gear matters",
          "It replaces the need for exposure gear entirely"
        ],
        "correct_index": 1,
        "explanation": "Understanding how and why the body loses heat in water is the reasoning behind choosing exposure protection suited to the conditions."
      },
      {
        "question": "Can warm, tropical water still cause dangerous heat loss?",
        "answers": [
          "Yes, prolonged unprotected exposure in warm water can still contribute to hypothermia",
          "No, warm water only ever risks overheating, never cold-related issues",
          "Only if the water temperature is below 70°F (21°C)"
        ],
        "correct_index": 0,
        "explanation": "Immersion-related hypothermia can occur even in water as warm as 84 to 91°F (29 to 33°C) during prolonged unprotected exposure, which is why the same early warning signs apply even when the water feels warm at first."
      }
    ]
  },
  "types-of-snorkeling-experiences": {
    "questions": [
      {
        "question": "Which type of snorkeling site is often recommended as a good starting point for newer snorkelers?",
        "answers": [
          "Wreck snorkeling",
          "Wall snorkeling",
          "Shallow reef snorkeling"
        ],
        "correct_index": 2,
        "explanation": "Shallow reefs close to shore often have calm water and good visibility, making them a good starting point for less experienced snorkelers."
      },
      {
        "question": "What might you expect to find at a wall snorkeling site?",
        "answers": [
          "A dramatic drop-off with a chance to see larger, open-ocean species",
          "Man-made structures only",
          "Only sandy, featureless terrain"
        ],
        "correct_index": 0,
        "explanation": "Wall sites feature a sudden drop-off into deeper water, often bringing encounters with larger species alongside typical reef life."
      },
      {
        "question": "What can sand snorkeling offer despite looking plain at first?",
        "answers": [
          "Guaranteed shark sightings",
          "Camouflaged creatures like stingrays and flounders",
          "The most colorful coral formations"
        ],
        "correct_index": 1,
        "explanation": "Sandy seabeds are home to camouflaged animals that blend into their surroundings, making them worth a closer look."
      },
      {
        "question": "What should you consider before choosing a snorkeling site type?",
        "answers": [
          "Nothing, all sites are equally suitable for any snorkeler",
          "Only the wildlife you hope to see",
          "Conditions and your comfort level, since these vary between site types"
        ],
        "correct_index": 2,
        "explanation": "Conditions and required experience vary significantly between site types, so matching the site to your comfort level and checking conditions matters."
      },
      {
        "question": "What's the safest approach at a wreck snorkeling site?",
        "answers": [
          "Swim through the interior to get the best photos",
          "Stay outside the structure rather than entering it",
          "Touch the structure to steady yourself as you look around"
        ],
        "correct_index": 1,
        "explanation": "Wreck interiors carry real entanglement and structural-collapse risk, and the structure itself can change over time, so staying outside is the safer default unless you have training specific to entering one."
      }
    ]
  },
  "marine-life-basics": {
    "questions": [
      {
        "question": "What distinguishes cartilaginous fish, like sharks and rays, from bony fish?",
        "answers": [
          "Cartilaginous fish have no skeleton at all",
          "Cartilaginous fish are always larger than bony fish",
          "Cartilaginous fish have skeletons made of cartilage instead of bone"
        ],
        "correct_index": 2,
        "explanation": "Cartilaginous fish, such as sharks and rays, have skeletons made of cartilage rather than bone, unlike the bony fish group."
      },
      {
        "question": "What helps bony fish control their buoyancy?",
        "answers": [
          "A swim bladder",
          "Their scales",
          "Their fins alone"
        ],
        "correct_index": 0,
        "explanation": "Bony fish have a swim bladder, an internal organ that helps them control buoyancy in the water."
      },
      {
        "question": "What is a defining feature of invertebrates?",
        "answers": [
          "They are always brightly colored",
          "They can only be found in sand",
          "They have no backbone"
        ],
        "correct_index": 2,
        "explanation": "Invertebrates are defined by having no backbone, and they come in a huge range of shapes, sizes, and colors."
      },
      {
        "question": "What is the recommended way to observe marine mammals while snorkeling?",
        "answers": [
          "Swim close to get a better look",
          "Keep a respectful distance and observe quietly",
          "Try to touch them if they approach"
        ],
        "correct_index": 1,
        "explanation": "Keeping a respectful distance and observing calmly avoids disturbing marine mammals' natural behavior."
      },
      {
        "question": "Why might you see a seal resting on rocks or a beach?",
        "answers": [
          "Seals, unlike whales and dolphins, are only semi-aquatic and regularly come ashore to rest and breed",
          "Seals are sick or injured whenever they're out of the water",
          "Seals can't actually swim, they only live on land"
        ],
        "correct_index": 0,
        "explanation": "Unlike fully aquatic dolphins and whales, seals are semi-aquatic and regularly haul out on land to rest, breed, and avoid predators, so seeing one out of the water is normal, healthy behavior."
      }
    ]
  },
  "coral-conservation-and-responsible-behavior": {
    "questions": [
      {
        "question": "What is the relationship between coral and zooxanthellae?",
        "answers": [
          "Zooxanthellae are a type of fish that lives near coral",
          "Zooxanthellae are parasites that harm coral",
          "Zooxanthellae are algae living in coral tissue that provide nutrients through photosynthesis"
        ],
        "correct_index": 2,
        "explanation": "Zooxanthellae are algae that live inside coral tissue, providing nutrients through photosynthesis in exchange for shelter and sunlight, a relationship central to reef ecosystems."
      },
      {
        "question": "Why should you avoid touching coral, even lightly?",
        "answers": [
          "Even light contact can transfer harmful bacteria or cause damage that takes years to heal",
          "Coral is not actually a living organism",
          "It has no real effect on the coral"
        ],
        "correct_index": 0,
        "explanation": "Coral is a living, slow-growing organism, and even light contact can transfer harmful bacteria or cause damage that takes a long time to heal."
      },
      {
        "question": "What is the difference between hard and soft coral?",
        "answers": [
          "There is no meaningful difference",
          "Hard coral has a calcium carbonate skeleton; soft coral has a flexible, fleshy body",
          "Hard coral is not alive; soft coral is alive"
        ],
        "correct_index": 1,
        "explanation": "Hard corals secrete calcium carbonate skeletons that form reef structures, while soft corals have flexible bodies without a hard skeleton."
      },
      {
        "question": "How does controlled kicking technique relate to reef conservation?",
        "answers": [
          "It has no connection to conservation",
          "Kicking technique only matters for speed, not conservation",
          "A controlled kick, like the frog kick, reduces the chance of accidental contact with coral"
        ],
        "correct_index": 2,
        "explanation": "A controlled, low-disturbance kick reduces the risk of accidentally touching or damaging coral while snorkeling nearby."
      },
      {
        "question": "What is a simple everyday way to support marine conservation beyond your time in the water?",
        "answers": [
          "Reduce plastic use and support sustainable seafood choices",
          "There is nothing effective an individual can do",
          "Avoid all seafood entirely"
        ],
        "correct_index": 0,
        "explanation": "Everyday choices like reducing plastic use and choosing sustainable seafood contribute to healthier oceans over time, alongside responsible in-water behavior."
      }
    ]
  },
  "prescription-masks-nearsightedness-farsightedness-lens-selection": {
    "questions": [
      {
        "question": "What does SPH usually describe on a prescription?",
        "answers": [
          "The base spherical correction",
          "The strap size of a mask",
          "The skirt color"
        ],
        "correct_index": 0,
        "explanation": "SPH is the base spherical correction value used in a prescription."
      },
      {
        "question": "What do CYL and AXIS relate to?",
        "answers": [
          "Astigmatism correction",
          "Fin stiffness",
          "Snorkel angle"
        ],
        "correct_index": 0,
        "explanation": "CYL describes astigmatism correction, and AXIS describes its orientation."
      },
      {
        "question": "If ADD is not used in the standard distance-lens recommendation, what should you conclude?",
        "answers": [
          "ADD is not part of the standard distance-lens recommendation",
          "Presbyopia can never matter underwater",
          "AXIS and ADD are the same thing"
        ],
        "correct_index": 0,
        "explanation": "ADD relates to near power and presbyopia. It is not used in the standard distance-lens recommendation, but that does not make near-vision needs irrelevant."
      },
      {
        "question": "Which left/right combination is supported in current Oceans Optics prescription mask systems when both strengths are available for the chosen model?",
        "answers": [
          "Left -2.00 and Right -3.50",
          "Left -3.00 and Right +4.00 as a normal stock configuration",
          "Any custom optical configuration without checking support"
        ],
        "correct_index": 0,
        "explanation": "Different supported sphere powers in each eye are available. A mixed plus/minus combination is not supported as a normal stock interchangeable-lens setup."
      },
      {
        "question": "Which tool should you use for prescription-strength guidance?",
        "answers": [
          "Lens Calculator",
          "Mask Sizing Tool",
          "A fin comparison chart"
        ],
        "correct_index": 0,
        "explanation": "The Lens Calculator supports prescription-strength selection; the Mask Sizing Tool supports physical fit."
      },
      {
        "question": "Why doesn't Oceans Optics recommend calculating spherical equivalent yourself and applying it directly for a high cylinder prescription?",
        "answers": [
          "Underwater optics change how a given lens value performs, so a value calculated the way it would be for glasses doesn't automatically translate to the right strength underwater",
          "Spherical equivalent is never used by Oceans Optics under any circumstance",
          "Cylinder readings are always ignored regardless of strength"
        ],
        "correct_index": 0,
        "explanation": "Spherical equivalent is one input Oceans Optics uses for higher cylinder prescriptions, as a directional check, not a formula customers should calculate and rely on alone."
      }
    ]
  }
};
